export default "__VITE_ASSET__a6a452e8__"